import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip, TextField, Zoom } from '@mui/material'
import useStyles from './TextFieldWithTooltip.style'

const TextFieldWithTooltip = ({
  tooltipTitle, label, value, handleValue, disabled = false, error = false,
}) => {
  const { classes } = useStyles()

  return (
    <Tooltip
      classes={{ tooltip: classes.tooltip, popper: classes.popper }}
      TransitionComponent={Zoom}
      title={tooltipTitle}
      arrow
      open={!disabled}
    >
      <TextField
        disabled={disabled}
        label={label}
        variant="standard"
        value={disabled ? '' : value}
        onChange={handleValue}
        error={error}
      />
    </Tooltip>
  )
}

TextFieldWithTooltip.propTypes = {
  tooltipTitle: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  handleValue: PropTypes.func.isRequired,
  // Defaults provided via destructuring parameters (avoids deprecated FC defaultProps).
  // eslint-disable-next-line react/require-default-props
  disabled: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  error: PropTypes.bool,
}

export default TextFieldWithTooltip
